import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Options, ProfileInput } from '../profile';
import { ProfileService } from '../services/profile.service';

/**
 * Base route guard to control the accessibility for a given route
 */
@Injectable({
  providedIn: 'root',
})
export class ProfileBaseGuard implements CanActivate, CanLoad {
  public isAuthorized: boolean = false;

  /**
   * For guards using the base canActivate method, indicates if owner is required.
   */
  public ownerRequired: boolean = true;
  protected readonly options: Options;

  constructor(
    @Inject('profileInput') protected readonly profileInput: ProfileInput,
    protected router: Router,
    protected profileService: ProfileService
  ) {
    this.options = this.profileInput.options;
    this.isAuthorized = !(
      this.options.isSkillInventoryProfile ||
      this.options.isSkillAnalyticsProfile
    );
  }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    // page requires owner
    if (
      route.data.ownerRequired &&
      !this.profileService.ownerAuthorizedForGuard(route.parent)
    ) {
      return false;
    }

    if (!this.isAuthorized) {
      const parentUrl = this.getParentUrl(route, state);
      return this.router.parseUrl(`${parentUrl}overview`);
    }
    return this.isAuthorized;
  }

  public canLoad(_: Route): boolean {
    return this.isAuthorized;
  }

  public getParentUrl(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): string {
    const value = state.url.slice(
      0,
      state.url.indexOf(route.url[route.url.length - 1].path)
    );
    return value;
  }
}
